module.exports = __webpack_public_path__ + "img/bg.d6183ee0.jpg";